
import { localStorageHyperDashboardTools } from '../../utils/tools/localStorageHyperDashboardTools';

// address
export const ADDRESS_VALIDATION =           '/address/validate';

// designated enroller
export const PARTNER_BROKER =               '/designated/enroller/profile/${encryptedHouseholdId}';

// hub
export const COUNTRIES =                    '/hub/getCountryOfIssuanceList';

// indportal
export const COMMUNICATION_PREFERENCES =    '/indportal/communicationPreferences';
export const DASHBOARD_MODELS_LITE =        '/indportal/dashboardModelsLite';

// newssap
export const AFFORDABILITY =                '/newssap/configuration/affordability/${coverageYear}';
export const BLOOD_RELATIONSHIPS =          '/newssap/relationships';
export const BLOOD_RELATIONSHIPS_ALL =      '/newssap/commonRelationships';
export const CHECK_BLOOD_RELATIONSHIPS =    '/newssap/validateRelationships';
export const COUNTIES_FOR_ZIPCODE =         '/newssap/countiesforstate/${state}/${postalCode}';
export const SSAP_DATA =                    '/newssap/application/${ssapApplicationId}';
export const SSAP_DATA_PREVIOUS =           '/newssap/application/${ssapApplicationId}/previous';
export const SSAP_DATA_SAVE =               '/newssap/save';
export const SSAP_FLOW =                    '/newssap/configuration';
export const SSAP_SETTINGS =                '/newssap/settings?year=${year}';
export const SSNS =                         '/newssap/ssns';
export const TRIBES =                       '/newssap/stateswithtribes';

// reviewSummarydownload
export const SUMMARY_TO_INBOX =             '/reviewSummarydownload/ssap/sendSummaryToInbox?caseNumber=${caseNumber}';

// root (hix)

export const ENROLLMENTS =                  '/hasActiveHealthEnrollmentByGuid';

// ui
export const ENVIRONMENT =                  '/ui/environment';

const ENDPOINTS_CONFIG = {
    [ENVIRONMENT]: [ ENVIRONMENT, 'stateCode' ],
    [BLOOD_RELATIONSHIPS]: [ BLOOD_RELATIONSHIPS, 'stateCode' ]
};

const paramMaker = {
    stateCode: () => localStorageHyperDashboardTools.getValueByPropName('stateCode', 'NV')
};

export const getURL = (url = '', replacements = {}) => {
    if(global.__ENV__.PRODUCTION) {
        return url.processReplacements(replacements);
    }

    // Here (Development mode) we need to prettify code

    if(Array.isArray(ENDPOINTS_CONFIG[url])) {
        const [ urlFromConfig, param1 ] = ENDPOINTS_CONFIG[url];
        return `${urlFromConfig}/${paramMaker[param1]()}.json`;
    } else {
        const regex = /[=?]/g;
        return `${url.processReplacements(replacements)}/index.json`.replace(regex, '/');
    }
};